import { render } from "./Index.vue?vue&type=template&id=a8333b3a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script